import { Outlet, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useLayoutEffect } from 'react'
import CookieBanner from '../components/CookieBanner'

export default function AppLayout() {
  const location = useLocation()

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [location.pathname])

  return (
    <div className='app-wrapper'>
      <Header />
      <Outlet />
      <Footer />
      <CookieBanner />
    </div>
  )
}
